// extracted by mini-css-extract-plugin
export var arrows = "_t-6";
export var decrementer = "_t-a";
export var disabled = "_t-4";
export var error = "_t-1";
export var hiddenText = "_t-b";
export var incrementer = "_t-9";
export var input = "_t-8";
export var inputWrapper = "_t-0";
export var leadingIcon = "_t-c";
export var readonly = "_t-3";
export var regular = "_t-7";
export var small = "_t-5";
export var warning = "_t-2";